import { z } from 'zod';

/** Згенеровані документи, до яких завантажують підписаний скан. */
export const SIGNED_DOC_KINDS = ['contract', 'amendment', 'act', 'protocol', 'register'] as const;
export type SignedDocKind = (typeof SIGNED_DOC_KINDS)[number];

export const SIGNED_DOC_KIND_LABELS: Record<SignedDocKind, string> = {
  contract: 'Договір',
  amendment: 'Додаткова угода',
  act: 'Акт наданих послуг',
  protocol: 'Протокол конкурсу',
  register: 'Реєстр винагород',
};

/** Поля multipart-форми завантаження скана (файли — окремо). */
export const signedUploadFieldsSchema = z.object({
  kind: z.enum(SIGNED_DOC_KINDS),
  entityId: z.uuid(),
  /** Дата підписання; порожньо — невідома. */
  signedAt: z.iso.date().optional(),
  note: z.string().trim().max(500).optional(),
});

export const signedListSchema = z.object({
  kind: z.enum(SIGNED_DOC_KINDS),
  entityId: z.uuid(),
});
